<template>
    <DropdownMenu>
        <DropdownMenuTrigger>
            <span class="sr-only">Toggle navigation</span>
            <Icon name="bars" class="text-white text-2xl" />
        </DropdownMenuTrigger>
        <DropdownMenuContent>
            <HeaderRegionsSubMenu />
            <HeaderLanguageSubMenu />
            <HeaderCurrenciesSubMenu />
            <DropdownMenuItem as-child>
                <NuxtLink :to="localePath('/bom/import')">
                    {{ $t("Layout.BulkSearchLinkText") }}
                </NuxtLink>
            </DropdownMenuItem>
            <template v-if="isAuthenticated">
                <DropdownMenuItem v-for="link in accountMenuLinks" :key="link.to" as-child>
                    <NuxtLink :prefetch="false" v-bind="link">{{ link.title }}</NuxtLink>
                </DropdownMenuItem>
            </template>
            <DropdownMenuItem v-else as-child>
                <NuxtLink id="sign-in-button-mobile" :to="localePath('/sign-in')" :title="$t('Layout.LinkLogin')">
                    {{ $t("Layout.LinkLogin") }}
                </NuxtLink>
            </DropdownMenuItem>
        </DropdownMenuContent>
    </DropdownMenu>
</template>
<script setup>
const isAuthenticated = useStateIsAuthenticated();
const localePath = useLocalePath();
const accountMenuLinks = useAccountLinks();
</script>
